<template>
  <header v-if="!config.hiddenHeader" class="site-header">
    <div class="site-header__bar">
      <button v-if="config.enableMenu !== false" ref="menuButton" type="button" class="icon-button" :aria-label="$t('openMenu')" :aria-expanded="String(showMenu)" aria-controls="site-menu" @click="openMenu"><svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 5h16M4 12h16M4 19h16"/></svg></button>
      <a :href="homeUrl || undefined" class="brand" aria-label="H365"><span>H</span><b>365</b></a>
      <div class="site-header__actions">
        <a :href="loginUrl || undefined" class="topup">{{ $t('topup') }}</a>
        <a :href="accountUrl || undefined" class="icon-button" :aria-label="$t('account')">
          <svg width="21" height="21" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><circle cx="12" cy="8" r="4"/><path d="M4 22v-2a8 8 0 0 1 16 0v2"/></svg>
        </a>
      </div>
    </div>
    <div v-if="showMenu" class="menu-backdrop" @click.self="closeMenu">
      <div id="site-menu" ref="drawer" class="site-menu" role="dialog" aria-modal="true" :aria-label="$t('openMenu')" @keydown="handleKeydown">
        <div class="site-menu__heading"><a :href="homeUrl || undefined" class="brand" aria-label="H365"><span>H</span><b>365</b></a><button ref="closeButton" type="button" class="icon-button" :aria-label="$t('closeMenu')" @click="closeMenu">×</button></div>
        <label class="language">{{ $t('language') }}<select v-model="$i18n.locale" @change="rememberLocale($i18n.locale)"><option value="zh-TW">繁體中文</option><option value="zh-CN">简体中文</option></select></label>
        <nav :aria-label="$t('openMenu')">
          <a :href="link('/game/list') || undefined"><svg xmlns="http://www.w3.org/2000/svg" width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" class="lucide lucide-search-icon lucide-search"><path d="m21 21-4.34-4.34"></path><circle cx="11" cy="11" r="8"></circle></svg><span>{{ $t('onlineGames') }}</span></a>
          <button type="button" :aria-expanded="String(showStandalone)" aria-controls="standalone-menu" @click="showStandalone = !showStandalone"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download-icon lucide-download" aria-hidden="true"><path d="M12 15V3"></path><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><path d="m7 10 5 5 5-5"></path></svg><span>{{ $t('standaloneGames') }}</span><span aria-hidden="true">{{ showStandalone ? '−' : '+' }}</span></button>
          <div v-if="showStandalone" id="standalone-menu" class="submenu"><router-link :to="{ path: '/standalone-games', query: $route.query }" @click.native="closeMenu">Android</router-link></div>
          <a :href="link('/content-feed/list') || undefined"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-newspaper-icon lucide-newspaper" aria-hidden="true"><path d="M15 18h-5"></path><path d="M18 14h-8"></path><path d="M4 22h16a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2H8a2 2 0 0 0-2 2v16a2 2 0 0 1-4 0v-9a2 2 0 0 1 2-2h2"></path><rect width="8" height="4" x="10" y="6" rx="1"></rect></svg><span>{{ $t('industryNews') }}</span></a>
          <a :href="link('/event/list') || undefined"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-calendar-days-icon lucide-calendar-days" aria-hidden="true"><path d="M8 2v4"></path><path d="M16 2v4"></path><rect width="18" height="18" x="3" y="4" rx="2"></rect><path d="M3 10h18"></path><path d="M8 14h.01"></path><path d="M12 14h.01"></path><path d="M16 14h.01"></path><path d="M8 18h.01"></path><path d="M12 18h.01"></path><path d="M16 18h.01"></path></svg><span>{{ $t('events') }}</span></a>
          <a :href="link('/news/list') || undefined"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-megaphone-icon lucide-megaphone" aria-hidden="true"><path d="M11 6a13 13 0 0 0 8.4-2.8A1 1 0 0 1 21 4v12a1 1 0 0 1-1.6.8A13 13 0 0 0 11 14H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2z"></path><path d="M6 14a12 12 0 0 0 2.4 7.2 2 2 0 0 0 3.2-2.4A8 8 0 0 1 10 14"></path><path d="M8 6v8"></path></svg><span>{{ $t('news') }}</span></a>
          <a v-if="!config.hiddenFAQ" :href="link('/qa') || undefined"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-circle-question-mark-icon lucide-circle-question-mark" aria-hidden="true"><circle cx="12" cy="12" r="10"></circle><path d="M9.09 9a3 3 0 0 1 5.83 1c0 2-3 3-3 3"></path><path d="M12 17h.01"></path></svg><span>{{ $t('FAQ') }}</span></a>
          <a href="https://bitbucket.org/h365g/h365g/src/main"><svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-bookmark-icon lucide-bookmark" aria-hidden="true"><path d="M17 3a2 2 0 0 1 2 2v15a1 1 0 0 1-1.496.868l-4.512-2.578a2 2 0 0 0-1.984 0l-4.512 2.578A1 1 0 0 1 5 20V5a2 2 0 0 1 2-2z"></path></svg><span>{{ $t('bookmark') }}</span></a>
          <a href="https://happymall.me/tc/home"><img :src="adultStoreIcon" alt="" class="store-icon" /><span>{{ $t('adultStore') }}</span></a>
        </nav>
      </div>
    </div>
  </header>
</template>

<script>
import adultStoreIcon from '@/assets/adult-store-icon.svg'
import { officialLink, isDesktopBrowser, rememberLocale, withQuery } from '@/utils/navigation'

export default {
  name: 'SiteHeader',
  props: {
    config: { type: Object, required: true },
    queryString: { type: String, default: '' }
  },
  data() {
    return { adultStoreIcon, showMenu: false, showStandalone: false, savedOverflow: '' }
  },
  computed: {
    homeUrl() { return this.link('') },
    accountBase() {
      if (!this.homeUrl) return ''
      if (this.config.accountURL) return withQuery(this.config.accountURL)
      // Same production account-domain convention as the official portal.
      const url = new URL(this.homeUrl)
      const parts = url.hostname.split('.')
      if (parts.length < 3) return ''
      return `https://account.${parts.slice(1).join('.')}`
    },
    accountUrl() {
      if (!this.accountBase) return ''
      const url = new URL(this.accountBase)
      url.searchParams.set('language', this.$i18n.locale)
      url.searchParams.set('authCallback', this.homeUrl)
      return url.toString()
    },
    loginUrl() {
      if (!this.accountBase) return ''
      const url = new URL(this.accountBase)
      const callback = new URL(this.link('/auth'))
      callback.searchParams.set('redirectUrl', this.homeUrl)
      url.searchParams.set('language', this.$i18n.locale)
      url.searchParams.set('referer', callback.toString())
      return url.toString()
    }
  },
  watch: {
    homeUrl: {
      immediate: true,
      handler(url) {
        if (!url || !isDesktopBrowser(window.navigator, window.innerWidth)) return
        // A misconfigured logoURL must never create a redirect loop.
        if (new URL(url).origin !== window.location.origin) window.location.replace(url)
      }
    }
  },
  beforeDestroy() {
    if (this.showMenu) document.body.style.overflow = this.savedOverflow
  },
  methods: {
    rememberLocale,
    link(path) { return officialLink(this.config.logoURL, this.$i18n.locale, this.queryString, path) },
    openMenu() {
      this.savedOverflow = document.body.style.overflow
      document.body.style.overflow = 'hidden'
      this.showMenu = true
      this.$nextTick(() => this.$refs.closeButton.focus())
    },
    closeMenu() {
      this.showMenu = false
      document.body.style.overflow = this.savedOverflow
      this.$nextTick(() => this.$refs.menuButton?.focus())
    },
    handleKeydown(event) {
      if (event.key === 'Escape') this.closeMenu()
      if (event.key !== 'Tab') return
      const nodes = this.$refs.drawer.querySelectorAll('a[href], button, select')
      const first = nodes[0]
      const last = nodes[nodes.length - 1]
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault()
        last.focus()
      }
      else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault()
        first.focus()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.site-header { color: #f5f5f1; background: #111210; position: fixed; top: 0; left: 0; width: 100%; z-index: 30; }
.site-header__bar { height: 52px; display: flex; align-items: center; gap: 8px; padding: 0 12px; }
.brand { display: inline-flex; gap: 3px; align-items: center; font-size: 28px; line-height: 1; font-weight: 900; color: #f5f5f1; text-decoration: none; }
.brand b { background: #f5c400; color: #111210; border-radius: 3px; padding: 1px 3px; font-size: 23px; }
.site-header__actions { margin-left: auto; display: flex; align-items: center; gap: 8px; }
.icon-button { display: inline-flex; align-items: center; justify-content: center; width: 40px; height: 44px; background: none; border: 0; color: inherit; font-size: 25px; cursor: pointer; text-decoration: none; }
.topup { background: #f5c400; color: #111210; font-weight: 700; padding: 7px 10px; border-radius: 4px; font-size: 13px; text-decoration: none; }
.menu-backdrop { position: fixed; inset: 0; background: #0008; z-index: 100; }
.site-menu { width: min(320px, 90vw); height: 100%; overflow-y: auto; padding: 12px; background: #191a17; box-sizing: border-box; }
.site-menu__heading { display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px; }
.site-menu__heading .brand { font-size: 22px; }
.site-menu__heading .brand b { font-size: 19px; }
.language { display: flex; align-items: center; justify-content: space-between; padding: 12px; font-size: 14px; border-bottom: 1px solid #3b3c36; }
.language select { background: #24251f; color: inherit; padding: 8px; border: 1px solid #55564e; border-radius: 4px; }
nav { margin-top: 12px; }
nav a, nav button { box-sizing: border-box; display: flex; align-items: center; justify-content: space-between; width: 100%; min-height: 44px; padding: 12px; margin: 3px 0; border: 0; border-radius: 4px; background: none; color: inherit; text-decoration: none; font: inherit; font-size: 14px; text-align: left; cursor: pointer; }
nav a > span, nav button > span:first-of-type { flex: 1; margin-left: 12px; }
nav .store-icon { width: 17px; height: 17px; object-fit: contain; flex-shrink: 0; filter: brightness(0) invert(1); }
nav a:hover .store-icon { filter: brightness(0); }
nav svg { flex-shrink: 0; width: 17px; height: 17px; }
nav a:hover, nav button:hover { background: #f5c400; color: #111210; }
.submenu { padding-left: 20px; }
:focus-visible { outline: 2px solid #f5c400; outline-offset: 2px; }
</style>